"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
// THIS FILES IS GENERATED USING SCRIPT, DO NOT EDIT DIRECTLY
var utilities_1 = require("../../common-theme/utilities");
var _a = utilities_1["default"].longhandUtils, borderRadius = _a.borderRadius, borderWidth = _a.borderWidth, margin = _a.margin, padding = _a.padding;
var utilities = {
    'typography-h1': { fontSize: '4.2rem', lineHeight: '4.8rem', fontWeight: '600' },
    'typography-h2': { fontSize: '2.4rem', lineHeight: '2.9rem', fontWeight: '600' },
    'typography-h3': { fontSize: '2rem', lineHeight: '2.6rem', fontWeight: '600' },
    'typography-h4': { fontSize: '1.6rem', lineHeight: '2.4rem', fontWeight: '600' },
    'typography-h5': { fontSize: '1.6rem', lineHeight: '2.2rem', fontWeight: '600' },
    'typography-h6': { fontSize: '1.4rem', lineHeight: '2rem', fontWeight: '600' },
    'typography-h7': { fontSize: '1.3rem', lineHeight: '2.2rem', fontWeight: '600' },
    'typography-b1': { fontSize: '1.3rem', lineHeight: '1.8rem', fontWeight: '600' },
    'typography-b2': { fontSize: '1.2rem', lineHeight: '1.6rem', fontWeight: '600' },
    'typography-bl1': { fontSize: '1.4rem', lineHeight: '2rem', fontWeight: '400' },
    'typography-bl2': { fontSize: '1.3rem', lineHeight: '2rem', fontWeight: '400' },
    'typography-bl3': { fontSize: '1.2rem', lineHeight: '1.8rem', fontWeight: '400' },
    'typography-bs1': { fontSize: '1.4rem', lineHeight: '2rem', fontWeight: '400' },
    'typography-bs2': { fontSize: '1.3rem', lineHeight: '1.8rem', fontWeight: '400' },
    'typography-bs3': { fontSize: '1.2rem', lineHeight: '1.6rem', fontWeight: '400' },
    'typography-l1': { fontSize: '1.3rem', lineHeight: '1.8rem', fontWeight: '400' },
    'typography-l2': { fontSize: '1.2rem', lineHeight: '1.6rem', fontWeight: '400' },
    'typography-l3': { fontSize: '1.1rem', lineHeight: '1.6rem', fontWeight: '400' },
    'typography-l4': { fontSize: '1rem', lineHeight: '1.4rem', fontWeight: '400' },
    'spr-ui-01': { backgroundColor: 'var(--spr-ui-01, #FFFFFF)' },
    'spr-ui-02': { backgroundColor: 'var(--spr-ui-02, #F8F8FA)' },
    'spr-ui-03': { backgroundColor: 'var(--spr-ui-03, #DBDBDB)' },
    'spr-ui-04': { backgroundColor: 'var(--spr-ui-04, #0E61F6)' },
    'spr-ui-05': { backgroundColor: 'var(--spr-ui-05, #EEF0F1)' },
    'spr-ui-06': { backgroundColor: 'var(--spr-ui-06, #E6E6E9)' },
    'spr-ui-focus': { backgroundColor: 'var(--spr-ui-focus, rgba(8, 40, 204, 0.07))' },
    'spr-ui-focus-reverse': { backgroundColor: 'var(--spr-ui-focus-reverse, rgba(255, 255, 255, 0.2))' },
    'spr-ui-hover': { backgroundColor: 'var(--spr-ui-hover, #F8F8FA)' },
    'spr-ui-hover-reverse': { backgroundColor: 'var(--spr-ui-hover-reverse, rgba(255, 255, 255, 0.1))' },
    'spr-support-error': { backgroundColor: 'var(--spr-support-error, #C70F5C)' },
    'spr-support-error-highlight': { backgroundColor: 'var(--spr-support-error-highlight, rgba(199, 15, 92, 0.2))' },
    'spr-support-success': { backgroundColor: 'var(--spr-support-success, #6AC96E)' },
    'spr-support-success-highlight': {
        backgroundColor: 'var(--spr-support-success-highlight, rgba(106, 201, 110, 0.2))'
    },
    'spr-support-warning': { backgroundColor: 'var(--spr-support-warning, #F3BF24)' },
    'spr-support-warning-highlight': { backgroundColor: 'var(--spr-support-warning-highlight, rgba(243, 191, 36, 0.2))' },
    'spr-clr-blue-highlight': { backgroundColor: 'var(--spr-clr-blue-highlight, #E8F0FE)' },
    'spr-tag': { backgroundColor: 'var(--spr-tag, #F2F2F4)' },
    'spr-tag-01': { backgroundColor: 'var(--spr-tag-01, #E6E6E9)' },
    'spr-tag-02': { backgroundColor: 'var(--spr-tag-02, rgba(8, 40, 204, 0.07))' },
    'spr-field': { backgroundColor: 'var(--spr-field, #DBDBDB)' },
    'spr-popup': { backgroundColor: 'var(--spr-popup, #FFFFFF)' },
    'spr-overlay': { backgroundColor: 'var(--spr-overlay, rgba(10, 10, 20, 0.9))' },
    'spr-tooltip-01': { backgroundColor: 'var(--spr-tooltip-01, #0A0A14)' },
    'spr-highlight': { backgroundColor: 'var(--spr-highlight, rgba(255, 231, 173, 0.7))' },
    'spr-favourite': { backgroundColor: 'var(--spr-favourite, #FF9F21)' },
    'spr-notification': { backgroundColor: 'var(--spr-notification, #DE336A)' },
    'spr-interactive-01': { backgroundColor: 'var(--spr-interactive-01, #0E61F6)' },
    'spr-interactive-hover': { backgroundColor: 'var(--spr-interactive-hover, #1858CE)' },
    'spr-interactive-disable': { backgroundColor: 'var(--spr-interactive-disable, rgba(255, 255, 255, 0.6))' },
    'spr-interactive-02': { backgroundColor: 'var(--spr-interactive-02, #DBDBDB)' },
    'spr-clr-blue': { backgroundColor: 'var(--spr-clr-blue, #2EA2FB)' },
    'spr-clr-green': { backgroundColor: 'var(--spr-clr-green, #33CC99)' },
    'spr-clr-lavender': { backgroundColor: 'var(--spr-clr-lavender, #7F36F6)' },
    'spr-clr-orange': { backgroundColor: 'var(--spr-clr-orange, #F08C1A)' },
    'spr-clr-pink': { backgroundColor: 'var(--spr-clr-pink, #FFA1BE)' },
    'spr-clr-red': { backgroundColor: 'var(--spr-clr-red, #E1245E)' },
    'spr-clr-sea': { backgroundColor: 'var(--spr-clr-sea, #16AAD2)' },
    'spr-clr-teal': { backgroundColor: 'var(--spr-clr-teal, #13C18D)' },
    'spr-clr-yellow': { backgroundColor: 'var(--spr-clr-yellow, #ECAD00)' },
    'spr-clr-grey': { backgroundColor: 'var(--spr-clr-grey, #D7D7DC)' },
    'spr-interactive-focus': { borderColor: 'var(--spr-interactive-focus, #132a86)' },
    'spr-clr-purple': { backgroundColor: 'var(--spr-clr-purple, #8C43FF)' },
    'spr-clr-lt-yellow': { backgroundColor: 'var(--spr-clr-lt-yellow, #FFD04F)' },
    'spr-clr-darker-blue': { backgroundColor: 'var(--spr-clr-darker-blue, #327AFD)' },
    'spr-secondary-yellow': { backgroundColor: 'var(--spr-secondary-yellow, #FFC312)' },
    'spr-secondary-green': { backgroundColor: 'var(--spr-secondary-green, #A3CB38)' },
    'spr-secondary-teal': { backgroundColor: 'var(--spr-secondary-teal, #12CBC4)' },
    'spr-secondary-lt-pink': { backgroundColor: 'var(--spr-secondary-lt-pink, #FDA7DF)' },
    'spr-secondary-pink': { backgroundColor: 'var(--spr-secondary-pink, #ED4C67)' },
    'spr-secondary-maroon': { backgroundColor: 'var(--spr-secondary-maroon, #B53471)' },
    'spr-secondary-orange': { backgroundColor: 'var(--spr-secondary-orange, #F48749)' },
    'spr-clr-magenta': { backgroundColor: 'var(--spr-clr-magenta, #CB1CCE)' },
    'spr-clr-fuschia': { backgroundColor: 'var(--spr-clr-fuschia, #A70FDC)' },
    'spr-clr-violet': { backgroundColor: 'var(--spr-clr-violet, #8E43FF)' },
    'spr-clr-lt-violet': { backgroundColor: 'var(--spr-clr-lt-violet, #E4DFF2)' },
    'spr-icon-01': { fill: 'var(--spr-icon-01, #0A0A14)' },
    'spr-icon-02': { fill: 'var(--spr-icon-02, #646470)' },
    'spr-icon-03': { fill: 'var(--spr-icon-03, #818192)' },
    'spr-icon-04': { fill: 'var(--spr-icon-04, #0E61F6)' },
    'spr-icon-05': { fill: 'var(--spr-icon-05, #FFFFFF)' },
    'spr-icon-06': { fill: 'var(--spr-icon-06, rgba(255, 255, 255, 0.6))' },
    'spr-icon-hover': { fill: 'var(--spr-icon-hover, #0A0A14)' },
    'spr-icon-disable': { fill: 'var(--spr-icon-disable, #DBDBDB)' },
    'spr-icon-hover-reverse': { fill: 'var(--spr-icon-hover-reverse, #FFFFFF)' },
    'spr-icon-error': { fill: 'var(--spr-icon-error, #C70F5C)' },
    'spr-link': { color: 'var(--spr-link, #0E61F6)' },
    'spr-text-01': { color: 'var(--spr-text-01, #0A0A14)' },
    'spr-text-02': { color: 'var(--spr-text-02, #434350)' },
    'spr-text-03': { color: 'var(--spr-text-03, #646470)' },
    'spr-text-04': { color: 'var(--spr-text-04, #0E61F6)' },
    'spr-text-05': { color: 'var(--spr-text-05, #FFFFFF)' },
    'spr-text-06': { color: 'var(--spr-text-06, #FFFFFF)' },
    'spr-text-magenta': { color: 'var(--spr-text-magenta, #CB1CCE)' },
    'spr-text-placeholder': { color: 'var(--spr-text-placeholder, #646470)' },
    'spr-support-error-text': { color: 'var(--spr-support-error-text, #C70F5C)' },
    'spr-support-success-text': { color: 'var(--spr-support-success-text, #6AC96E)' },
    'spr-support-warning-text': { color: 'var(--spr-support-warning-text, #F3BF24)' },
    'spr-hover': { borderColor: 'var(--spr-hover, #0729a0)' },
    'spr-focus-01': { borderColor: 'var(--spr-focus-01, #0E61F6)' },
    'spr-border-01': { borderColor: 'var(--spr-border-01, #EEEEEE)' },
    'spr-border-02': { borderColor: 'var(--spr-border-02, #E6E6E9)' },
    'spr-border-03': { borderColor: 'var(--spr-border-03, #DBDBDB)' },
    'spr-border-04': { borderColor: 'var(--spr-border-04, #818192)' },
    'spr-border-05': { borderColor: 'var(--spr-border-05, #FFFFFF)' },
    'spr-border-06': { borderColor: 'var(--spr-border-06, #0A0A14)' },
    'spr-card-border': { borderColor: 'var(--spr-card-border, #ECECEF)' },
    'spr-popup-border': { borderColor: 'var(--spr-popup-border, #D7D7DC)' },
    'spr-tooltip-border': { borderColor: 'var(--spr-tooltip-border, #0A0A14)' },
    'spr-focus-02': { outline: 'var(--spr-focus-02, 1px solid #0E61F6)' },
    'spr-shadow-01': { boxShadow: 'var(--spr-shadow-01, 0 1px 4px 0 rgba(10,10,20,0.15))' },
    'spr-shadow-02': { boxShadow: 'var(--spr-shadow-02, 0 2px 8px 0 rgba(10,10,20,0.20))' },
    'spr-shadow-03': { boxShadow: 'var(--spr-shadow-03, -2px 9px 12px 0 rgba(10,10,20,0.60))' },
    'spr-shadow-04': { boxShadow: 'var(--spr-shadow-04, -2px 5px 12px -4px rgba(10,10,20,.20))' },
    'spr-shadow-05': { boxShadow: 'var(--spr-shadow-05, 0px 3px 4px 0 rgba(0,0,0,0.1))' },
    'spr-shadow-06': { boxShadow: 'var(--spr-shadow-06, 0px -3px 4px 0 rgba(0,0,0,0.1))' },
    'nav-ui-01': { backgroundColor: 'var(--nav-ui-01, rgba(255, 255, 255, 0.2))' },
    'nav-ui-hover-01': { backgroundColor: 'var(--nav-ui-hover-01, rgba(255, 255, 255, 0.3))' },
    'nav-icon-01': { fill: 'var(--nav-icon-01, rgba(255, 255, 255, 0.9))' },
    'nav-icon-focus-01': { fill: 'var(--nav-icon-focus-01, #0E61F6)' },
    'nav-text-01': { color: 'var(--nav-text-01, rgba(255, 255, 255, 0.9))' },
    'ai-ui-01': { background: 'var(--ai-ui-01, linear-gradient(88.6879deg, #DE46E1, #8E43FF 48.7%, #0E61F6 100%))' },
    'ai-ui-02': {
        background: 'var(--ai-ui-02, linear-gradient(233.63deg, #FCF0FD 18.56%, #F7F0FE 52.51%, #ECF2FE 87.9%))'
    },
    'ai-ui-03': {
        background: 'var(--ai-ui-03, linear-gradient(181.44deg, rgba(222, 70, 225, 0.2) -1.57%, rgba(142, 67, 255, 0.2) 79.59%, rgba(14, 97, 246, 0.2) 113.86%))'
    },
    'ai-border-01': {
        background: 'linear-gradient(#FFFFFF, #FFFFFF) padding-box, linear-gradient(88.6879deg, #DE46E1, #8E43FF 48.7%, #0E61F6 100%) border-box',
        borderColor: 'transparent'
    },
    'ai-highlight': { backgroundColor: 'var(--ai-highlight, #E4DFF2)' },
    'outline-01': { outlineStyle: 'solid', outlineWidth: '2px', outlineColor: '#0E61F6', outlineOffset: '2px' }
};
exports["default"] = __assign(__assign({}, utilities_1["default"].utilities), utilities);
